/**
 * OWNER: W0 (orchestrator). `Core: CoreCommands` (ARCHITECTURE.md §15): an ASSEMBLY of the per-group command
 * consts, no logic. Groups are implemented by W1-10a (notes, lines, tempo, doc, merge) and W1-10b (keys,
 * transform, clipboard) in their own files; this file never changes when they land.
 */

import { clipboardCommands } from './clipboard';
import { keyCommands } from './keys';
import { lineCommands } from './lines';
import { mergeCommands } from './merge';
import { docCommands } from './meta';
import { noteCommands } from './notes';
import { tempoCommands } from './tempo';
import { transformCommands } from './transform';
import type { CoreCommands } from './types';

export const Core: CoreCommands = {
  notes: noteCommands,
  keys: keyCommands,
  lines: lineCommands,
  tempo: tempoCommands,
  doc: docCommands,
  transform: transformCommands,
  clipboard: clipboardCommands,
  merge: mergeCommands,
};
